import React from "react";
import "./BioSection.css";

function BioSection() {
  return (
    <section id="bio" className="section section-bio">
      <div className="section-inner">
        <div className="bio-grid">
          {/* Colonna sinistra - Titolo pulito */}
          <div className="bio-left">
            <div className="bio-title-block">
              <h2 className="section-title">Bio</h2>
            </div>
          </div>

          {/* Colonna destra - Contenuto testo */}
          <div className="bio-right">
            <div className="bio-content">
              <p>
                <span className="bio-decorative-line"></span>
                Sono uno studente del <mark className="highlight">Master in Digital Innovation and New Business Design</mark> presso la <mark className="highlight">POLIMI Graduate School of Management</mark>, con specializzazione in <mark className="highlight">Digital Product &amp; Strategy</mark>.
              </p>
              <p>
                Ho un solido background accademico in <mark className="highlight">ICT Engineering</mark> (Laurea Magistrale) e <mark className="highlight">Ingegneria Informatica</mark> (Laurea Triennale), maturato tra il <mark className="highlight">Politecnico di Milano</mark> e l'<mark className="highlight">Università della Calabria</mark>.
              </p>
              <p>
                Integro competenze analitiche e tecniche con <mark className="highlight">pensiero strategico e critico</mark> e una forte capacità di <mark className="highlight">problem solving</mark>, con un interesse particolare per la <mark className="highlight">trasformazione digitale</mark>, la <mark className="highlight">creazione di valore attraverso la tecnologia</mark> e il <mark className="highlight">project management</mark>.
              </p>
              <p>
                Al di fuori dell'ambito accademico, coltivo la mia passione per la <mark className="highlight">musica</mark> come spazio di espressione creativa, attraverso la <mark className="highlight">produzione di brani</mark>, le <mark className="highlight">esibizioni dal vivo</mark> e l'<mark className="highlight">organizzazione di eventi</mark>.
              </p>
              <p>
                Attualmente sono alla ricerca di opportunità che mi permettano di costruire <mark className="highlight">connessioni sempre più significative con le persone</mark>, sviluppare <mark className="highlight">progetti</mark> ed <mark className="highlight">esperienze</mark> in contesti collaborativi e creativi e vivere il lavoro in modo positivo, sia per me che per gli altri.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Forme geometriche enfatizzate */}
      <div className="bio-shapes">
        <div className="bio-shape bio-shape-main"></div>
        <div className="bio-shape bio-shape-secondary"></div>
        <div className="bio-shape bio-shape-accent"></div>
      </div>
    </section>
  );
}

export default BioSection;
